import { jsxs as N, jsx as u } from "react/jsx-runtime";
import { useState as h } from "react";
import { TextInput as W } from "./textInput.js";
import { u as b } from "./index-6a632112.mjs";
import { D as F, a as M, A as B } from "./searchInputLocation.const-9a2c3a62.mjs";
import { Q as I, b as g, r as m, s as d, l as z } from "./themes-5f0b3c3d.mjs";
import { t as i } from "./textStyles-42cab346.mjs";
import "./uniqueId-321287e8.mjs";
import "./lineHeights-72d3110c.mjs";
import "./accessibility.js";
import "./label-3b996c7d.mjs";
import "./tooltip.js";
import "./useWindowDimensions.js";
import "./zIndices-d07533f3.mjs";
import "./getElementPosition-5026bb28.mjs";
import "./popupTip.js";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./types-b577bf77.mjs";
import "./iconButton.js";
import "./button.js";
import "./checkmarkFilled-c2b01ef1.mjs";
import "./informationFilled-05d57719.mjs";
import "./helperText-698f3ed9.mjs";
import "./warningFilled-691cfde1.mjs";
import "./fontWeights-a25f8f91.mjs";
const s = {
  HOME: "home",
  END: "end",
  PREV: "prev",
  NEXT: "next"
}, l = {
  UP: 38,
  DOWN: 40,
  LEFT: 37,
  RIGHT: 39,
  TAB: 9,
  ENTER: 13,
  HOME: 36,
  END: 35,
  SPACE: 32,
  ESC: 27
}, K = "Address Input", G = "221px", j = "442px", V = "266px", X = "584px", Q = b.div`
  position: relative;
  width: ${G};
  @media ${I.laptopAndUp} {
    width: ${j};
  }
`, q = b.div`
  position: absolute;
  width: ${V};
  overflow: auto;
  top: 75px;
  display: flex;
  flex-direction: column;
  border-bottom: 0px;
  box-shadow: 0 ${g["2x"]} ${g["1x"]} 0 rgba(0, 20, 46, 0.1);
  max-height: 250px;
  box-sizing: border-box;
  @media ${I.laptopAndUp} {
    width: ${X};
  }
  color: ${(t) => t.theme.components.addressInput.color};
  border: ${g["1x"]} solid
    ${(t) => t.theme.components.addressInput.borderColor};
  border-radius: ${m["2x"]};
  background-color: ${(t) => t.theme.components.addressInput.backgroundColor};
  padding: ${d["2x"]} ${d["2x"]} ${d["3x"]} ${d["2x"]};
  z-index: 100;
`, J = b.div`
  font-family: 'Inter', sans-serif;
  padding: ${d["2x"]};
  cursor: pointer;
  letter-spacing: ${z[0]};
  display: block;
  height: auto;
  background-color: ${(t) => {
  if (t.isOptionActive)
    return t.theme.components.addressInput.backgroundColorOnHover;
}};

  ${({ textSize: t }) => {
  if (t === "small")
    return `
         font-size: ${i.body.medium.s.fontSize};
      border-radius: ${m["1x"]};
      line-height: ${i.body.medium.s.lineHeight};
            `;
  if (t === "medium")
    return `
            font-size: ${i.body.medium.m.fontSize};
      border-radius: ${m["2x"]};
      line-height: ${i.body.medium.m.lineHeight};
            `;
  if (t === "large")
    return `
      font-size: ${i.body.medium.l.fontSize};
      border-radius: ${m["3x"]};

      line-height: ${i.body.medium.l.lineHeight};
                  `;
}}
  &:hover {
    background-color: ${(t) => t.theme.components.addressInput.backgroundColorOnHover};
  }
`;
function _e({
  textSize: t = "medium",
  value: Y,
  onChange: Z,
  onInput: ee,
  longitude: D = F,
  lat: T = M,
  apiKey: O,
  limit: S = "5",
  pattern: te,
  disabled: A,
  labelProp: k,
  infoProp: _,
  trailingText: y,
  isRequired: E = !0,
  showErrorIcon: P = !1,
  ...v
}) {
  const [L, $] = h(""), [n, p] = h(-1), [r, a] = h(
    []
  ), w = r.length > 0, f = (e) => {
    $(e), a([]), p(-1);
  }, H = () => {
    a([]);
  }, R = (e) => {
    const o = e.target.value;
    if ($(o), o.length > 1) {
      const C = `${B}${T},${D}&limit=${S}&lang=en&q=${o}&apiKey=${O}`;
      fetch(C).then((c) => c.json()).then((c) => a(c.items));
    } else
      a([]);
  }, x = (e) => {
    let o = -1;
    switch (e) {
      case s.HOME:
        o = -1;
        break;
      case s.END:
        o = r.length - 1;
        break;
      case s.NEXT:
        n >= r.length - 1 ? o = -1 : o = n + 1;
        break;
      case s.PREV:
        n <= -1 ? o = r.length - 1 : o = n - 1;
        break;
    }
    p(o);
  }, U = (e) => {
    switch (e.keyCode) {
      case l.ENTER:
        e.stopPropagation(), e.preventDefault(), f(r[n]?.title);
        break;
      case l.ESC:
        e.target.blur(), a([]);
        break;
      case l.UP:
        e.preventDefault(), x(s.PREV);
        break;
      case l.DOWN:
        e.preventDefault(), x(s.NEXT);
        break;
      default:
        e.preventDefault();
        break;
    }
  };
  return /* @__PURE__ */ N(Q, { children: [
    /* @__PURE__ */ u(
      W,
      {
        value: L,
        type: "tel",
        "aria-autocomplete": "list",
        labelProp: {
          showRequiredIndicator: E,
          label: K,
          ...k
        },
        infoProp: { ..._ },
        trailingText: y,
        textSize: t,
        "aria-describedby": "FMCPredictiveSearchInstructions",
        "aria-activedescendant": "",
        isRequired: E,
        onChange: R,
        disabled: A,
        showErrorIcon: P,
        onBlur: () => {
          setTimeout(() => {
            H();
          }, 150);
        },
        onKeyDown: (e) => {
          (e.key === "ArrowDown" || e.key === "ArrowUp" || e.key === "Enter" || e.key === "Escape") && U(e);
        },
        ...v
      }
    ),
    w && /* @__PURE__ */ u(q, { children: r && r.map((e, o) => /* @__PURE__ */ u(
      J,
      {
        role: "option",
        isOptionActive: o === n,
        onClick: () => f(e.title),
        onMouseOver: () => p(o),
        onMouseLeave: () => p(-1),
        textSize: t,
        children: e?.title
      },
      o
    )) })
  ] });
}
export {
  _e as AddressInput
};
